/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Labs_Threshold_DescInputs */

const en_ui_labs_threshold_desc = /** @type {(inputs: Ui_Labs_Threshold_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To generate training plans, set your threshold pace in Settings. This is your pace at lactate threshold — roughly your 1-hour race pace.`)
};

const de_ui_labs_threshold_desc = /** @type {(inputs: Ui_Labs_Threshold_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für Trainingspläne brauchst du dein Schwellentempo — das ist ungefähr dein 1-Stunden-Wettkampftempo. Stell es in den Einstellungen ein.`)
};

/**
* | output |
* | --- |
* | "To generate training plans, set your threshold pace in Settings. This is your pace at lactate threshold — roughly your 1-hour race pace." |
*
* @param {Ui_Labs_Threshold_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_labs_threshold_desc = /** @type {((inputs?: Ui_Labs_Threshold_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Labs_Threshold_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_labs_threshold_desc(inputs)
	return de_ui_labs_threshold_desc(inputs)
});